// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"621":"74acd18b","708":"b9b0113d","933":"ebc0449d"}[chunkId] + ".chunk.js";
};